import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign } from "helpers/helpers"

function Index({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])

	async function searchWithFilter() {
		var filterUrl = "/report-summary-allowances"
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.menu_ids && filterData.menu_ids.length > 0) {
			const ids = filterData.menu_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'menu_ids=' + ids;
		}
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={true}
				animation={false}
				centered
				size="md"
				onHide={() => setActiveModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('allowances')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '80%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="text-center">1</td>
									<td>{t('service')}</td>
									<td className="text-end">{formatMoney(data?.service_amount)}</td>
								</tr>
								<tr>
									<td className="text-center">2</td>
									<td>{t('delivery')}</td>
									<td className="text-end">{formatMoney(data?.total_delivery_price)}</td>
								</tr>
								<tr>
									<td className="text-center">3</td>
									<td>{t('allowances')}</td>
									<td className="text-end">{formatMoney(data?.total_surcharge)}</td>
								</tr>
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-end"><b>{formatMoney(data?.total_allowances)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index